const dummy = [
  {
    name: 'Juan Sanchez',
    email: 'juanSanchez@email.com',
    password: 'Admin@123',
    userRol: 'Admin',
  },
  {
    name: 'Martha Rodriguez',
    email: 'marta@mail.com',
    password: '12345678',
    userRol: 'User',
  },
  {
    name: 'Carlos Cueva',
    email: 'carlosCueva@email.com',
    password: '12345678',
    userRol: 'Staff',
  },
  {
    name: 'Maria Castro',
    email: 'mariaCastro@email.com',
    password: '12345678',
    userRol: 'Staff',
  },
];

export default dummy;
